import { render, staticRenderFns } from "./course-list.vue?vue&type=template&id=a2e87d64&"
import script from "./course-list.vue?vue&type=script&lang=ts&"
export * from "./course-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "course-list.vue"
export default component.exports